const eFileMadeEasyColors = {
    green: "#3a6d31",
    greener: "#528634",
    blue: "#004fcc",
    darkBlue: "#002d56",
};
export default eFileMadeEasyColors;
